import getApiV2Parameters from '../v2/getApiV2Parameters';

/**
 * @param {TimesGridState} state
 * @param {moment} startDate
 * @param {int} numDays
 */
export default function getApiV3Parameters(state, startDate, numDays) {
    return {
        ...getApiV2Parameters(state, startDate, numDays),
        carrier_id: state.insuranceCarrier,
        directory_id: state.directoryId,
        is_reschedule: state.isReschedule,
        plan_id: state.insurancePlan,
        widget: state.widget,
    };
}
